import httpService from './httpService';

export default {
  getDailyAttend,
  loadMonthlyAttends,
  updateEmpAttend,
  updateEmpAttendByDate,
};
function getDailyAttend(date) {
  return httpService.get(`attend/daily${_createFilterUrl({ date })}`);
}
function loadMonthlyAttends(filterBy) {
  return httpService.get(`attend${_createFilterUrl(filterBy)}`);
}
function updateEmpAttend(empAttend, attendDate) {
  return httpService.put(`attend/${attendDate}`, empAttend);
}
function updateEmpAttendByDate(empId, date) {
  return httpService.put(`attend`, { empId, date });
}

const _createFilterUrl = (filterBy) => {
  let filters = [];
  for (let filterKey in filterBy) {
    if (filterBy[filterKey])
      filters.push(filterKey + '=' + filterBy[filterKey]);
  }
  return filters.length ? '?' + filters.join('&') : '';
};
